import type { LocalizedText } from '../../shared/types';

export type SupportedLang = 'zh-HK' | 'zh-CN' | 'en';

export const supportedLangs: SupportedLang[] = ['zh-HK', 'zh-CN', 'en'];

export const langLabels: Record<SupportedLang, string> = {
  'zh-HK': '繁',
  'zh-CN': '简',
  en: 'EN',
};

export function createLocalizedText(
  zhHK: string,
  zhCN: string,
  en: string
): LocalizedText {
  return { 'zh-HK': zhHK, 'zh-CN': zhCN, en };
}

export function getLocalizedText(
  value: string | LocalizedText | unknown,
  lang: SupportedLang,
  fallback?: string
): string {
  if (typeof value === 'string') {
    return value || fallback || '';
  }
  if (value && typeof value === 'object') {
    const localized = value as Partial<LocalizedText>;
    const candidates = [localized[lang], localized['zh-HK'], localized['zh-CN'], localized.en, fallback];
    for (const candidate of candidates) {
      if (typeof candidate === 'string' && candidate.length > 0) {
        return candidate;
      }
    }
  }
  return fallback || '';
}

export function updateLocalizedText(
  value: string | LocalizedText | unknown,
  lang: SupportedLang,
  text: string
): LocalizedText {
  const base: LocalizedText = { 'zh-HK': '', 'zh-CN': '', en: '' };
  if (value && typeof value === 'object') {
    Object.assign(base, value);
  }
  base[lang] = text;
  return base;
}

export function localizeField(
  content: Record<string, unknown>,
  field: string,
  lang: SupportedLang
): string {
  return getLocalizedText(content[field], lang);
}
